import React, { type PropsWithChildren } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@sg/garnish';

import { BUNDLE_FOOTER_MIN_BOTTOM_SPACING } from '../../Bundle.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const BundleFooter = (props: PropsWithChildren) => {
  const { children } = props;

  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerDynamicStyles = useStyle(
    () => ({ paddingBottom: Math.max(BUNDLE_FOOTER_MIN_BOTTOM_SPACING, safeAreaBottomInset) }),
    [safeAreaBottomInset],
  );

  const containerStyles = [styles.container, containerDynamicStyles];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <LinearGradient
      colors={GRADIENT_COLORS}
      end={GRADIENT_END}
      locations={GRADIENT_LOCATIONS}
      pointerEvents="box-none"
      start={GRADIENT_START}
      style={containerStyles}
    >
      {children}
    </LinearGradient>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GRADIENT_COLORS = [
  'rgba(248, 247, 240, 0)',
  'rgba(248, 247, 240, 0.82)',
  'rgba(248, 247, 240, 0.9)',
] as const;

const GRADIENT_LOCATIONS = [0, 0.6, 1] as const;
const GRADIENT_START = { x: 0, y: 0 } as const;
const GRADIENT_END = { x: 0, y: 1 } as const;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    paddingTop: theme.spacing['20'],
    paddingHorizontal: theme.spacing['4'],
  },
});
